"use client"

// Site-wide floating contact buttons, both configurable; these are public contact
// details, so a fallback is fine.
//
// One line carries both: Riya answers WhatsApp and the phone on the same number.
// (+971585800342 appears in the Asterisk dialplan but is the LiveKit SIP routing
// identifier, not a number anyone dials.)
const CONTACT_NUMBER = (process.env.NEXT_PUBLIC_WHATSAPP_NUMBER || "971585172112").replace(/\D/g, "");
const CALL_NUMBER = (process.env.NEXT_PUBLIC_CALL_NUMBER || CONTACT_NUMBER).replace(/\D/g, "");
const PREFILL = "Hi HOPO Homes, I'd like to know more.";

const ContactButtons = () => {
    const href = `https://wa.me/${CONTACT_NUMBER}?text=${encodeURIComponent(PREFILL)}`;

    return (
        // Stacked so the pair reads as one control and neither covers the other on a
        // narrow screen. WhatsApp sits lowest: it is the one most people reach for.
        <div className="fixed bottom-5 right-5 z-50 flex flex-col-reverse items-center gap-3 md:bottom-8 md:right-8">
        <a
            href={href}
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
            className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 hover:scale-110 hover:shadow-xl"
        >
            <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden="true">
                <path d="M16.003 3C9.373 3 3.996 8.377 3.996 15.007c0 2.117.553 4.185 1.605 6.007L3 29l8.2-2.552a12.02 12.02 0 0 0 4.803 1.003h.004C22.63 27.451 28 22.075 28 15.444 28 8.814 22.633 3 16.003 3zm0 21.79h-.003a9.96 9.96 0 0 1-4.077-.882l-.293-.132-4.867 1.514 1.548-4.744-.19-.303a9.86 9.86 0 0 1-1.516-5.245c0-5.48 4.463-9.937 9.95-9.937 2.658 0 5.155 1.036 7.033 2.916a9.86 9.86 0 0 1 2.912 7.03c-.001 5.481-4.463 9.938-9.95 9.938zm5.458-7.443c-.299-.15-1.77-.874-2.045-.973-.274-.1-.474-.15-.673.15-.199.298-.772.973-.947 1.172-.174.2-.349.224-.648.075-.299-.15-1.263-.466-2.406-1.485-.889-.793-1.489-1.772-1.663-2.07-.174-.3-.019-.461.131-.61.135-.134.3-.349.449-.523.15-.174.199-.299.299-.498.1-.2.05-.374-.025-.523-.075-.15-.673-1.622-.922-2.222-.243-.583-.489-.504-.673-.513l-.573-.01c-.199 0-.523.075-.797.374-.274.299-1.046 1.023-1.046 2.495 0 1.472 1.071 2.895 1.22 3.094.15.2 2.107 3.218 5.105 4.513.714.308 1.27.492 1.704.63.716.228 1.368.196 1.884.119.575-.086 1.77-.724 2.02-1.423.249-.699.249-1.298.174-1.423-.074-.124-.273-.199-.572-.349z" />
            </svg>
        </a>

        <a
            href={`tel:+${CALL_NUMBER}`}
            aria-label="Call us"
            className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white shadow-lg transition-transform duration-300 hover:scale-110 hover:shadow-xl"
        >
            <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true">
                <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.03-.24c1.12.37 2.33.57 3.56.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.4 21 3 13.6 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.44.57 3.56a1 1 0 0 1-.25 1.03l-2.2 2.2z" />
            </svg>
        </a>
        </div>
    );
};

export default ContactButtons;
